<form [formGroup]="form" fxLayout="column" fxLayoutAlign="start" fxLayoutGap="15px">
	<!-- Add helptext message when component is disabled -->
	<div *ngIf="disabled" class="disabled-message mat-caption" style="color: #f44336; margin-bottom: 12px;">
		<mat-icon style="font-size: 16px; height: 16px; width: 16px; vertical-align: middle; margin-right: 4px;">info</mat-icon>
		{{type === 'origin' ? 'Pickup' : 'Delivery'}} Completed - {{type === 'origin' ? 'Origin' : 'Destination'}} address can no longer be edited.
	</div>
	
	<div>
		<mat-button-toggle-group #grp="matButtonToggleGroup" (change)="onValueChange(grp.value)"
								 [value]="addressEntryMode" fxLayout="row wrap" fxLayoutAlign="start" [disabled]="disabled">
      <mat-button-toggle *ngIf="user?.globalSettings?.enableGooglePlacesSearch && !user?.inetUser?.addressBookLocked" [value]="'GOOGLE_SEARCH'"
							   fxFlex [matTooltip]="'Google Places'" [matTooltipPosition]="'below'" [attr.data-testid]="type === 'origin' ? 'origin-google-places-toggle' : 'destination-google-places-toggle'" [disabled]="disabled">
				<mat-icon>
					<svg viewBox="0 0 488 512" xmlns="http://www.w3.org/2000/svg">
						<path d="M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z"/>
					</svg>
				</mat-icon>
			</mat-button-toggle>
			<mat-button-toggle *ngIf="user?.inetUser?.allowAddressBookAccess" [value]="'ADDRESS_BOOK'"
							   fxFlex [matTooltip]="'Address Book'" [matTooltipPosition]="'below'" [attr.data-testid]="type === 'origin' ? 'origin-address-book-toggle' : 'destination-address-book-toggle'" [disabled]="disabled">
				<mat-icon>book</mat-icon>
			</mat-button-toggle>
      <mat-button-toggle (click)="dropPin()" *ngIf="user?.globalSettings?.enableGooglePlacesSearch && !user?.inetUser?.addressBookLocked" fxFlex
							   [matTooltip]="'Drop Pin'" [matTooltipPosition]="'below'" [attr.data-testid]="type === 'origin' ? 'origin-drop-pin-toggle' : 'destination-drop-pin-toggle'" [disabled]="disabled">
				<mat-icon>pin_drop</mat-icon>
			</mat-button-toggle>
      <mat-button-toggle *ngIf="user?.inetUser?.allowAddressBookAccess" (click)="scanAddressBarcode()" fxFlex [matTooltip]="'Location and Lookup Barcodes'"
							   [matTooltipPosition]="'below'" [value]="'BARCODE_SEARCH'" [attr.data-testid]="type === 'origin' ? 'origin-barcode-search-toggle' : 'destination-barcode-search-toggle'" [disabled]="disabled">
				<mat-icon><i class="fas fa-barcode"></i></mat-icon>
			</mat-button-toggle>
      <mat-button-toggle *ngIf="!user?.inetUser?.addressBookLocked" (click)="address?.address1 ? openAddressModal(address, false, address?.name) : openAddressModal(null, false, address?.addressInput)"
							   [value]="'MANUAL_ENTRY'" fxFlex [matTooltip]="'Enter Manually'" [matTooltipPosition]="'below'" [attr.data-testid]="type === 'origin' ? 'origin-manual-entry-toggle' : 'destination-manual-entry-toggle'" [disabled]="disabled">
				<mat-icon>text_format</mat-icon>
			</mat-button-toggle>
		</mat-button-toggle-group>
	</div>
	<mat-card [ngClass]="{'invalid':(formSubmitted && (address.country != 'OTHER' && (!address.address1 || !address.city || !address.zip)))}"
			  class="well" fxLayout="column" fxLayoutAlign="start"
			  fxLayoutGap="5px">
		<mat-card-content fxLayout="row" fxLayoutAlign="start">
			<div fxLayout="column" fxLayoutAlign="start">
				<mat-icon [color]="address?.address1 ? 'primary' : 'accent'">
					{{address?.address1 ? 'location_on' : 'location_off'}}
				</mat-icon>
			</div>
			<div fxLayout="column" fxLayoutAlign="start" [attr.data-testid]="type === 'origin' ? 'origin-address-container' : 'destination-address-container'">
				<ng-container *ngIf="!address?.address1">
					<p>{{'placeOrderView.noAddressSelectedText' | translate}}</p>
				</ng-container>
				<ng-container *ngIf="address?.address1">
					<div *ngIf="address?.name && address?.name !== address?.address1">
						{{address?.name}}
					</div>
					<div>
						{{address?.address1}}<span *ngIf="address?.address2">, {{address?.address2}}</span>
					</div>
					<div *ngIf="address?.country !== 'OTHER'">
						{{address?.city}}, {{address?.state}} {{address?.zip}} {{address?.plus4}}
					</div>
					<div *ngIf="address?.country === 'OTHER'">
						{{address?.city}}
					</div>
				</ng-container>
			</div>
		</mat-card-content>
		<div fxLayout="row wrap" fxLayoutAlign="space-between" fxLayoutGap="5px">
			<button (click)="openAddressModal(address.address1 ? address : null, false, address.address1 ? address?.name : address?.addressInput)"
					*ngIf="!user?.inetUser?.addressBookLocked" [color]="'primary'" mat-button type="button" [disabled]="disabled">
				{{address.address1 ? ('placeOrderView.editAddressButton' | translate) :
				('placeOrderView.newAddressButton' | translate)}}
			</button>
			<div *ngIf="address.address1 && !address?.id && user?.inetUser?.allowAddressBookAccess">
				<button (click)="saveAddress(address)" [color]="'primary'" mat-button type="button" [disabled]="disabled">
					{{'placeOrderView.addToAddressBookButton' | translate}}
				</button>
			</div>
		</div>
		<div *ngIf="(formSubmitted && (address.country != 'OTHER' && (!address.address1 || !address.city || !address.zip)))" class="well-error"
			 fxLayout="row"
			 fxLayoutAlign="start">
			<span *ngIf="type === 'origin'">
				{{selectedCustomer?.captions?.originCaption ? selectedCustomer?.captions?.originCaption : 'Origin'}}
				address required
			</span>
			<span *ngIf="type === 'destination'">
				{{selectedCustomer?.captions?.destCaption ? selectedCustomer?.captions?.destCaption : 'Destination'}}
				address required
			</span>
		</div>
	</mat-card>
	<mat-form-field *ngIf="addressEntryMode === 'GOOGLE_SEARCH'" fxLayout="column" fxLayoutAlign="stretch">
		<mat-label>{{'placeOrderView.searchGooglePlacesPlaceholder' | translate}}</mat-label>
		<input #googleSearch (selectedAddress)="setGoogleAddress($event)" appGoogleSearch formControlName="googleSearch"
			   matInput placeholder="Enter a location" type="text" [disabled]="disabled">
	</mat-form-field>
	<mat-form-field *ngIf="addressEntryMode === 'ADDRESS_BOOK'" fxLayout="column" fxLayoutAlign="stretch">
		<mat-label>{{'placeOrderView.searchAddressBookPlaceholder' | translate}}</mat-label>
		<input #addressBookSearch [matAutocomplete]="auto" formControlName="addressBookSearch" matInput
			placeholder="Enter a location" spellcheck="false" type="text" [disabled]="disabled">
		<mat-autocomplete #auto="matAutocomplete" (optionSelected)="setAddressBookAddress($event.option.value)"
						  [displayWith]="valueMapper" autoActiveFirstOption showPanel="true"
						  (infiniteScroll)="onScroll($event)">
		<mat-option *ngIf="isLoading">
			<mat-spinner diameter="30"></mat-spinner>
		</mat-option>
		<ng-container *ngIf="!isLoading" class="address-results-card">
			<mat-option *ngFor="let option of filteredAddressResults$ | async" [value]="option">
			<div>{{option.name}}</div>
			<div>{{option.address1}}</div>
			<div>{{option.address2}}</div>
			<div>{{option.city}}, {{option.state}} {{option.country === 'CA' ? option.zip + ' ' + option.plus4 : option.zip}}</div>
			<div class="bottom-border-row"></div>
			</mat-option>
		</ng-container>
		</mat-autocomplete>
	</mat-form-field>
	<mat-form-field *ngIf="addressEntryMode === 'BARCODE_SEARCH'" fxLayout="column" fxLayoutAlign="stretch">
		<mat-label>Search/Scan Location or Lookup Barcode</mat-label>
		<mat-label class="float-right">Exact Match Only</mat-label>
		<mat-slide-toggle (change)="setExactMatch($event)"
						  formControlName="exactMatch"
						  name="exactMatch"
						  class="float-right" [disabled]="disabled">
		</mat-slide-toggle>
		<input #barcode [matAutocomplete]="auto" formControlName="barcode"
			   matInput placeholder="Scan or manually enter barcode" spellcheck="false" type="text" [disabled]="disabled">
		<mat-autocomplete #auto="matAutocomplete"
						  [displayWith]="valueMapper" (optionSelected)="setAddressBookAddress($event.option.value);"
						  autoActiveFirstOption showPanel="true"
						  (infiniteScroll)="onScroll($event)">
			<mat-option *ngIf="isLoading">
				<mat-spinner diameter="30"></mat-spinner>
			</mat-option>
			<ng-container *ngIf="!isLoading" class="address-results-card">
				<mat-option *ngFor="let option of filteredAddressResults$ | async" [value]="option">
					<div>{{option.name}}</div>
					<div>{{option.address1}}</div>
					<div>{{option.address2}}</div>
					<div>{{option.city}}, {{option.state}} {{option.country === 'CA' ? option.zip + ' ' + option.plus4 : option.zip}}</div>
					<div class="bottom-border-row"></div>
				</mat-option>
			</ng-container>
		</mat-autocomplete>
	</mat-form-field>
</form>
